var _excluded = ["value", "height", "hideValue"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Flex, Box } from "./..";

var getDisplayValue = function getDisplayValue(value) {
  if (value <= 0) return 0;
  if (value >= 100) return 100;
  return value;
};

var getBaseProgressIndicatorStyle = function getBaseProgressIndicatorStyle() {
  return {
    borderRadius: 'inherit'
  };
};

var ProgressIndicator = function ProgressIndicator(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    width: "".concat(getDisplayValue(value), "%"),
    backgroundColor: getDisplayValue(value) === 100 ? 'green.600' : 'blue.500',
    _getBaseStyle: getBaseProgressIndicatorStyle
  });
};

var ProgressValue = function ProgressValue(_ref2) {
  var value = _ref2.value;
  return /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1,
    color: getDisplayValue(value) === 100 ? 'green.600' : 'blue.500'
  }, getDisplayValue(value), "%");
};

var getBaseProgressBarStyle = function getBaseProgressBarStyle() {
  return {
    borderRadius: '20px',
    height: 'inherit'
  };
};

var ProgressBar = function ProgressBar(_ref3) {
  var _ref3$value = _ref3.value,
      value = _ref3$value === void 0 ? 0 : _ref3$value,
      _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? '8px' : _ref3$height,
      _ref3$hideValue = _ref3.hideValue,
      hideValue = _ref3$hideValue === void 0 ? false : _ref3$hideValue,
      rest = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/React.createElement(Flex, _extends({}, rest, {
    alignItems: "center",
    paddingX: 2,
    paddingY: 3,
    height: height
  }), /*#__PURE__*/React.createElement(Flex, {
    flexGrow: 4,
    backgroundColor: "grey.300",
    _getBaseStyle: getBaseProgressBarStyle,
    marginRight: hideValue ? 0 : 2
  }, /*#__PURE__*/React.createElement(ProgressIndicator, {
    value: value
  })), !hideValue && /*#__PURE__*/React.createElement(ProgressValue, {
    value: value
  }));
};

ProgressBar.displayName = 'ProgressBar';
export { ProgressBar };
export default ProgressBar;